import momentTimezone from 'moment-timezone'

// Shared by the match change pages and components

export const STATUS = {
    voting: { label: 'Σε ψηφοφορία', icon: 'mdi-vote-outline', tone: 'info' },
    pending: { label: 'Αναμένει έγκριση διοργάνωσης', icon: 'mdi-timer-sand', tone: 'warn' },
    approved: { label: 'Εγκρίθηκε', icon: 'mdi-check-circle-outline', tone: 'ok' },
    rejected: { label: 'Δεν εγκρίθηκε από τη διοργάνωση', icon: 'mdi-close-circle-outline', tone: 'bad' },
    declined: { label: 'Απορρίφθηκε από ομάδα', icon: 'mdi-close-circle-outline', tone: 'bad' },
    expired: { label: 'Έληξε', icon: 'mdi-clock-alert-outline', tone: 'muted' },
    cancelled: { label: 'Ακυρώθηκε από την ομάδα', icon: 'mdi-cancel', tone: 'muted' }
}

const ERROR_MESSAGES = {
    MATCH_CHANGE_NOT_ALLOWED: 'Οι αγώνες δεν μπορούν να ανταλλάξουν ώρα.',
    MATCH_CHANGE_DEADLINE_PASSED: 'Η προθεσμία έληξε.',
    MATCH_CHANGE_ALREADY_REQUESTED: 'Υπάρχει ήδη ανοιχτό αίτημα αλλαγής για έναν από τους αγώνες.',
    MATCH_CHANGE_NOT_VOTING: 'Η ψηφοφορία έχει ολοκληρωθεί.',
    MATCH_CHANGE_NOT_VOTER: 'Η ομάδα σας δεν ψηφίζει σε αυτό το αίτημα.',
    MATCH_CHANGE_ALREADY_VOTED: 'Η ομάδα σας έχει ήδη ψηφίσει.',
    MATCH_CHANGE_ALREADY_REVIEWED: 'Το αίτημα έχει ήδη ολοκληρωθεί.',
    POSTPONEMENT_ALREADY_REVIEWED: 'Η διοργάνωση έχει ήδη απαντήσει στο αίτημα.',
    NOT_REQUESTER_TEAM: 'Μόνο η ομάδα που έκανε το αίτημα μπορεί να το ακυρώσει.',
    NOT_TEAM_CAPTAIN: 'Μόνο ο αρχηγός της ομάδας μπορεί να το κάνει.',
    NO_PLAYER_ON_TEAM: 'Ο παίκτης του προφίλ σας δεν ανήκει στην ομάδα. Ενημερώστε το προφίλ σας.',
    PLAYER_NOT_FOUND: 'Ο παίκτης του προφίλ σας δεν βρέθηκε. Ενημερώστε το προφίλ σας.',
    MATCH_NOT_INCLUDES_TEAM: 'Η ομάδα σας δεν συμμετέχει σε αυτόν τον αγώνα.'
}

export function errorMessage(error, fallback) {
    const data = (error && error.response && error.response.data) || {}
    return ERROR_MESSAGES[data.code] || fallback || 'Κάτι πήγε στραβά. Δοκιμάστε ξανά.'
}

// the captain of the team that made the request (as picked on the profile): the request can be cancelled while open
export function isMyRequest(store, teamId) {
    const team = store.getters.getTeam
    return !!store.getters.getCaptain && !!team && team.id === teamId
}

export function formatDate(date, format = 'ddd D MMM · HH:mm') {
    return date ? momentTimezone(date).tz('Europe/Athens').locale('el').format(format) : 'Χωρίς ημερομηνία'
}
